/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2215);
/******/ })
/************************************************************************/
/******/ ({

/***/ 2215:
/***/ (function(module, exports) {

var PRIVACY_POLICY_LINK = "https://www.edusocial-project.de/datenschutzerklaerung/datenschutz-edusocial-school-app/";
var EXTERNAL_SCHEME_SECURE = 'https-external://';
var ORIGINAL_SCHEME_SECURE = 'https://';
var EXTERNAL_SCHEME = 'http-external://';
var ORIGINAL_SCHEME = 'http://';
function replaceExternalLinks() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var aLink = document.getElementById("privacy-policy-link");
    aLink.href = PRIVACY_POLICY_LINK;
    if (userAgent.includes('mobile-native-')) {
        aLink.href = aLink.href.replace(ORIGINAL_SCHEME_SECURE, EXTERNAL_SCHEME_SECURE);
        aLink.href = aLink.href.replace(ORIGINAL_SCHEME, EXTERNAL_SCHEME);
    }
}
document.addEventListener("DOMContentLoaded", function (event) {
    replaceExternalLinks();
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/external-links.0ca04d8c86afe2ef.bundle.js